/** @format */

const generateId = () => {
  return String(Date.now());
};

export {generateId};
